
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Select from "@/components/form/Select.vue";
import AsnModule from "@/store/modules/asn";
import { getModule } from "vuex-module-decorators";
import { AsnLevel } from "@/models/api/asn/asn";
import { AsnFormula } from "@/models/api/asn/formula";
import AsnFormulaLine from "./AsnFormulaLine.vue";

const asnModule = getModule(AsnModule);

import _ from "lodash";

@Component({
    components: {
    Select,
    AsnFormulaLine
  }
})
export default class AsnFormulaModal extends Vue {

    @Prop()
    AsnFormulas: AsnFormula[];

    @Prop()
    Mappable: string[];

    async onFormulaUpdated(formula: AsnFormula){
        this.$emit('formula-updated', formula);
    }

    async onFormulaRemoved(formula: AsnFormula){
        this.$emit('formula-removed', formula);
    }

    async onFormulaAdded(){
        this.$emit('formula-added');
    }
}

